import { render, staticRenderFns } from "./UserTrendTabs.vue?vue&type=template&id=8f55231c&scoped=true"
import script from "./UserTrendTabs.vue?vue&type=script&lang=ts"
export * from "./UserTrendTabs.vue?vue&type=script&lang=ts"
import style0 from "./UserTrendTabs.vue?vue&type=style&index=0&id=8f55231c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f55231c",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/views/user-trend.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fuser-trend%2FUserTrendTabs.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports